// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/dragdrop-transparent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("public/img/magnifier.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #f4f4f4;
}

.dazzle .x_title h2 {
  float: left;
  margin: 10px 0 3px;
  font-size: 1.6em;
}

.dazzle .x_title .nav > li > a {
  cursor: pointer;
  padding: 0;
}

.dazzle .x_title .nav > li > a:hover, .dazzle .x_title .nav > li > a:active, .dazzle .x_title .nav > li > a:focus {
  background: none;
}

.dazzle .x_title .navbar-right {
  margin: 0;
}

.dashboard .list-group-item-heading {
  margin-bottom: 0;
  font-size: 1em;
}

.dashboard .box-header {
  text-align: left;
}

.dashboard .box-body-textrow {
  box-shadow: 0 1px 3px #0000004d !important;
}

.dashboard .group-summary-select-widget {
  margin: 0 15px;
}

.dashboard .group-summary-edit-groups {
  max-height: 350px;
  overflow-y: hidden;
}

.dashboard .addwidget-group-report.over {
  background: #eee;
}

.dashboard .DeviceChart-panel {
  width: 100%;
}

.dashboard-layout-field__layout-wrapper {
  background: var(--background-color);
  cursor: pointer;
  border: 1px solid #fff;
  border-radius: 3px;
  margin-bottom: 20px;
  padding: 10px;
}

.dashboard-layout-field__layout-wrapper:hover {
  border: 1px solid #d2d6de;
}

.dashboard-layout-field__td {
  border: 1px solid var(--background-color);
  border-right: 1px solid var(--background-color);
  text-align: center;
  background: #fff;
  padding: 8px 5px;
}

.dashboard-layout-field__td:last-of-type {
  border-right: 1px solid var(--background-color);
}

.dashboard-layout-field__td--hover {
  border-right: 1px solid #ddd;
}

.dashboard-layout-field__hover-block {
  cursor: pointer;
  z-index: 1;
  background: #ffffffb3;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  inset: 0;
}

.dashboard__empty-icon {
  width: 12px;
  display: inline-block;
}

.dashboard__empty-icon:empty:before {
  content: " ";
}

.dashboard__add-widget-item {
  border: 1px solid #fff;
  border-radius: 3px;
  margin-bottom: 8px;
  background: #f4f4f4 !important;
}

.dashboard__add-widget-item:last-of-type {
  margin-bottom: 0;
}

.dashboard__add-widget-item:hover {
  border: 1px solid #d2d6de;
}

.dashboard__add-widget-footer {
  border-top: 1px solid #f4f4f4;
  padding: 10px;
}

.dashboard-color-form__modify-groups-wrapper {
  flex-direction: row;
  padding-bottom: 25px;
  display: flex;
}

@media (width >= 1200px) {
  .dashboard-color-form__row {
    display: flex;
  }
}

.dashboard-color-form__widget-options-field-wrapper {
  flex-direction: column;
  flex: 50%;
  display: flex;
}

.dashboard-color-form__add-to-group-icon {
  color: #d2d6de;
  cursor: not-allowed;
  text-align: center;
  background: #eee;
  border: 1px solid #d2d6de;
  border-radius: 15px;
  width: 30px;
  height: 30px;
  padding-top: 6px;
}

.dashboard-color-form__add-to-group-icon--selected {
  color: #3c763d;
  cursor: pointer;
  background: #fff;
}

.dashboard-color-form__add-to-group-wrapper {
  z-index: 1;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 40px;
  margin: 0 5px;
  display: flex;
  position: relative;
}

.dashboard-color-form__add-to-group-wrapper:before {
  content: "";
  z-index: -1;
  border-left: 1px solid #f4f4f4;
  width: 1px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
}

.dashboard-color-form__group-report-path {
  margin-left: 35px;
  display: none;
}

@media (width >= 1200px) {
  .dashboard-color-form__group-report-path {
    display: inline-block;
  }
}

.dashboard-color-form__group-report-path-text {
  font-style: italic;
  font-weight: 500;
}

.dashboard-color-form__weight-input {
  border: 1px solid #d2d6de;
  height: 22px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.dashboard-color-form__weight-input--error {
  border: 1px solid #ff3232;
}

.dashboard-color-form__group-wrapper {
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 190px 115px;
  border: 0;
  height: 252px;
  padding: 0;
  overflow-y: auto;
}

.dashboard-color-form__group-wrapper--children {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: 1px solid #f4f4f4;
}

.dashboard-color-form__group-wrapper--over {
  background-color: #f5f5f5;
}

.dashboard-color-form__no-groups {
  border: 2px dashed #ddd;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  height: 249px;
  display: flex;
}

.dashboard-color-form__no-groups--error {
  border: 2px dashed #ff3232;
}

.dashboard-color-form__groups-th {
  max-width: 70px;
  border-bottom-width: 1px !important;
}

.dashboard-color-form__groups-th:first-of-type {
  width: auto;
}

.dashboard-color-form__groups-th:last-of-type {
  text-align: center;
  max-width: 40px;
}

.dashboard-color-form__groups-td {
  cursor: pointer;
  vertical-align: middle !important;
  border-top: 0 !important;
}

.dashboard-color-form__groups-td:last-of-type {
  text-align: center;
}

.dashboard-color-form__col {
  background: #f4f4f4;
  border: 1px solid #fff;
  border-radius: 3px;
  margin: 15px;
  padding-top: 15px;
}

.dashboard-color-form__col:hover {
  border: 1px solid #fff;
}

@media (width >= 1200px) {
  .dashboard-color-form__col {
    cursor: pointer;
    flex-direction: column;
    margin: 0 7px;
    display: flex;
  }

  .dashboard-color-form__col:first-of-type {
    margin-left: 14px;
  }

  .dashboard-color-form__col:last-of-type {
    margin-right: 14px;
  }
}

.dashboard-color-form__col--checked {
  border: 1px solid #3c8dbc;
}

.dashboard-color-form__empty-space {
  width: 13px;
}

.dashboard-color-form__empty-space:empty:before {
  content: " ";
}

.dashboard-color-form__caret-icon {
  cursor: pointer;
  width: 12px;
  padding-right: 4px;
}

.dashboard-color-form__tree-view-found-report-item {
  color: #aaa;
  cursor: not-allowed;
  padding: 3px 10px;
  font-weight: normal;
}

.dashboard-color-form__tree-view-found-report-item:hover {
  background: #fff;
}

.dashboard-color-form__tree-view-found-report-item--drag {
  color: inherit;
  cursor: pointer;
}

.dashboard-color-form__tree-view-found-report-item--drag:hover {
  background: #f5f5f5;
}

.dashboard-color-form__tree-view-found-report-item--selected {
  font-weight: bold;
}

.dashboard-color-form__tree-view-found-report-item-path {
  margin-left: 35px;
}

.dashboard-color-form__tree-view-found-report-item-path-text {
  font-style: italic;
  font-weight: 500;
}

.dashboard-color-form__tree-view-found-report-item-path-text--selected {
  font-style: italic;
  font-weight: bold;
}

.dashboard-color-form__tree-view-border-container {
  border: 1px solid #f4f4f4;
  height: 100%;
  overflow: auto;
}

.dashboard-color-form__tree-view-border-found-report-title {
  padding: 3px 10px;
  font-weight: bold;
}

.dashboard-color-form__tree-view-wrapper {
  flex-direction: column;
  flex: 50%;
  height: 330px;
  display: flex;
}

.dashboard-color-form__tree-view-wrapper--fixed-height {
  height: auto;
}

.dashboard-color-form__tree-view-item-wrapper {
  flex-direction: row;
  padding: 3px 10px;
  display: flex;
}

.dashboard-color-form__tree-view-report-item-wrapper {
  color: #aaa;
  cursor: not-allowed;
  background: #fff;
  align-items: center;
  font-weight: normal;
}

.dashboard-color-form__tree-view-report-item-wrapper:hover {
  background: #fff;
}

.dashboard-color-form__tree-view-report-item-wrapper--highlighted {
  background: #ff0;
}

.dashboard-color-form__tree-view-report-item-wrapper--selected {
  font-weight: bold;
}

.dashboard-color-form__tree-view-report-item-wrapper--drag {
  color: inherit;
  cursor: pointer;
}

.dashboard-color-form__tree-view-report-item-wrapper--drag:hover {
  background: #f5f5f5;
}

.dashboard-color-form__tree-view-search-input {
  background: none;
  width: auto;
  min-width: 170px;
  padding-left: 8px;
  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;
}

.dashboard-color-form__tree-view-search-input::placeholder {
  color: #ccc;
  padding-left: 20px;
}

.dashboard-color-form__tree-view-search-input--magnifier {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 8px 10px no-repeat;
}

.dashboard-text-row-form__table {
  width: auto;
  min-width: 380px;
  margin-bottom: 0;
}

.dashboard-text-row-form-first__td {
  text-align: center;
  width: 20px;
  vertical-align: middle !important;
}

.dashboard-custom-frame__panel-toolbox {
  min-height: auto;
}

.dashboard-custom-frame__panel-toolbox--editable {
  min-height: 1.42857em;
}

.dashboard-custom-frame__hover {
  cursor: pointer;
  z-index: 1;
  background: #ffffffb3;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  inset: 0;
}

.dashboard-edit-bar__row {
  margin-top: 10px;
  padding-right: 20px;
}

.dashboard-device-chart__title {
  font-size: 18px;
  font-weight: bold;
}

.dashboard-device-chart__col {
  width: 100%;
  min-width: 900px;
  position: relative;
}

@media (width >= 992px) {
  .dashboard-device-chart__col {
    min-width: 700px;
  }
}

.dashboard-vendor-mix__title {
  font-size: 18px;
  font-weight: bold;
}

.dashboard-table-color__summary-table-row {
  width: 100%;
}

@media (width >= 768px) {
  .dashboard-table-color__summary-table-row {
    clear: both;
    max-width: 550px;
  }
}

.dashboard-text-row__tr {
  border-bottom: 1px solid #fff;
}

.dashboard-text-row__tr:hover {
  border-bottom: 1px solid #f4f4f4;
}

.dashboard-text-row__td {
  text-align: left;
  white-space: normal;
  width: 1%;
  padding-top: 2px;
  padding-bottom: 2px;
}

.dashboard-text-row__value {
  float: right;
  margin-left: 20px;
}

.dashboard-text-row__wrapper {
  clear: both;
  width: 100%;
  max-width: 550px;
}

.dashboard-color-form__title-widget-input {
  width: auto;
  min-width: 170px;
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Dashboard/Overview/Dashboard.css","webpack://./services/frontend/app/pages/Dashboard/Overview/Dashboard.css"],"names":[],"mappings":"AADA;ECEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yDAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sEAA8D;AAChE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[":root {\n  --background-color: #f4f4f4;\n}\n\n.dazzle .x_title h2 {\n      float: left;\n      font-size: 1.6em;\n      margin: 10px 0 3px;\n    }\n\n.dazzle .x_title .nav > li > a {\n      cursor: pointer;\n      padding: 0;\n    }\n\n.dazzle .x_title .nav > li > a:hover,\n    .dazzle .x_title .nav > li > a:active,\n    .dazzle .x_title .nav > li > a:focus {\n      background: none;\n    }\n\n.dazzle .x_title .navbar-right {\n      margin: 0;\n    }\n\n.dashboard .list-group-item-heading {\n    font-size: 1em;\n    margin-bottom: 0;\n  }\n\n.dashboard .box-header {\n    text-align: left;\n  }\n\n.dashboard .box-body-textrow {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3) !important;\n  }\n\n.dashboard .group-summary-select-widget {\n    margin: 0 15px;\n  }\n\n.dashboard .group-summary-edit-groups {\n    max-height: 350px;\n    overflow-y: hidden;\n  }\n\n.dashboard .addwidget-group-report.over {\n    background: #eee;\n  }\n\n.dashboard .DeviceChart-panel {\n    width: 100%;\n  }\n\n.dashboard-layout-field__layout-wrapper {\n  background: var(--background-color);\n  border-radius: 3px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  padding: 10px;\n  border: 1px solid #fff;\n}\n\n.dashboard-layout-field__layout-wrapper:hover {\n    border: 1px solid #d2d6de;\n  }\n\n.dashboard-layout-field__td {\n  background: #fff;\n  border: 1px solid var(--background-color);\n  border-right: 1px solid var(--background-color);\n  padding: 8px 5px;\n  text-align: center;\n}\n\n.dashboard-layout-field__td:last-of-type {\n    border-right: 1px solid var(--background-color);\n  }\n\n.dashboard-layout-field__td--hover {\n  border-right: 1px solid #ddd;\n}\n\n.dashboard-layout-field__hover-block {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.7);\n  bottom: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.dashboard__empty-icon {\n  display: inline-block;\n  width: 12px;\n}\n\n.dashboard__empty-icon:empty:before {\n    content: '\\00a0';\n  }\n\n.dashboard__add-widget-item {\n  background: #f4f4f4 !important;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  margin-bottom: 8px;\n}\n\n.dashboard__add-widget-item:last-of-type {\n    margin-bottom: 0;\n  }\n\n.dashboard__add-widget-item:hover {\n    border: 1px solid #d2d6de;\n  }\n\n.dashboard__add-widget-footer {\n  border-top: 1px solid #f4f4f4;\n  padding: 10px;\n}\n\n.dashboard-color-form__modify-groups-wrapper {\n  display: flex;\n  flex-direction: row;\n  padding-bottom: 25px;\n}\n\n@media (min-width: 1200px) {\n\n.dashboard-color-form__row {\n    display: flex\n}\n  }\n\n.dashboard-color-form__widget-options-field-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 50%;\n}\n\n.dashboard-color-form__add-to-group-icon {\n  background: #eee;\n  border-radius: 15px;\n  border: 1px solid #d2d6de;\n  color: #d2d6de;\n  cursor: not-allowed;\n  height: 30px;\n  padding-top: 6px;\n  text-align: center;\n  width: 30px;\n}\n\n.dashboard-color-form__add-to-group-icon--selected {\n  background: #fff;\n  color: #3c763d;\n  cursor: pointer;\n}\n\n.dashboard-color-form__add-to-group-wrapper {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin: 0 5px;\n  width: 40px;\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-color-form__add-to-group-wrapper:before {\n    border-left: 1px solid #f4f4f4;\n    bottom: 0;\n    content: '';\n    left: 50%;\n    margin: 0 auto;\n    position: absolute;\n    top: 0;\n    width: 1px;\n    z-index: -1;\n  }\n\n.dashboard-color-form__group-report-path {\n  display: none;\n  margin-left: 35px;\n}\n\n@media (min-width: 1200px) {\n\n.dashboard-color-form__group-report-path {\n    display: inline-block\n}\n  }\n\n.dashboard-color-form__group-report-path-text {\n  font-style: italic;\n  font-weight: 500;\n}\n\n.dashboard-color-form__weight-input {\n  border: 1px solid #d2d6de;\n  height: 22px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.dashboard-color-form__weight-input--error {\n  border: 1px solid #ff3232;\n}\n\n.dashboard-color-form__group-wrapper {\n  background-color: #fff;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  border: 0;\n  height: 252px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.dashboard-color-form__group-wrapper--children {\n  background-image: url('public/img/dragdrop-transparent.png');\n  border: 1px solid #f4f4f4;\n}\n\n.dashboard-color-form__group-wrapper--over {\n  background-color: #f5f5f5;\n}\n\n.dashboard-color-form__no-groups {\n  align-items: center;\n  border-radius: 10px;\n  border: 2px dashed #ddd;\n  display: flex;\n  height: 249px;\n  justify-content: center;\n}\n\n.dashboard-color-form__no-groups--error {\n  border: 2px dashed #ff3232;\n}\n\n.dashboard-color-form__groups-th {\n  border-bottom-width: 1px !important;\n  max-width: 70px;\n}\n\n.dashboard-color-form__groups-th:first-of-type {\n    width: auto;\n  }\n\n.dashboard-color-form__groups-th:last-of-type {\n    text-align: center;\n    max-width: 40px;\n  }\n\n.dashboard-color-form__groups-td {\n  border-top: 0 !important;\n  cursor: pointer;\n  vertical-align: middle !important;\n}\n\n.dashboard-color-form__groups-td:last-of-type {\n    text-align: center;\n  }\n\n.dashboard-color-form__col {\n  background: #f4f4f4;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  padding-top: 15px;\n  margin: 15px;\n}\n\n.dashboard-color-form__col:hover {\n    border: 1px solid #fff;\n  }\n\n@media (min-width: 1200px) {\n\n.dashboard-color-form__col {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    margin: 0 7px\n}\n\n    .dashboard-color-form__col:first-of-type {\n      margin-left: 14px;\n    }\n\n    .dashboard-color-form__col:last-of-type {\n      margin-right: 14px;\n    }\n  }\n\n.dashboard-color-form__col--checked {\n  border: 1px solid #3c8dbc;\n}\n\n.dashboard-color-form__empty-space {\n  width: 13px;\n}\n\n.dashboard-color-form__empty-space:empty:before {\n    content: '\\00a0';\n  }\n\n.dashboard-color-form__caret-icon {\n  cursor: pointer;\n  padding-right: 4px;\n  width: 12px;\n}\n\n.dashboard-color-form__tree-view-found-report-item {\n  color: #aaa;\n  cursor: not-allowed;\n  font-weight: normal;\n  padding: 3px 10px;\n}\n\n.dashboard-color-form__tree-view-found-report-item:hover {\n    background: #fff;\n  }\n\n.dashboard-color-form__tree-view-found-report-item--drag {\n  color: inherit;\n  cursor: pointer;\n}\n\n.dashboard-color-form__tree-view-found-report-item--drag:hover {\n    background: #f5f5f5;\n  }\n\n.dashboard-color-form__tree-view-found-report-item--selected {\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path {\n  margin-left: 35px;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path-text {\n  font-style: italic;\n  font-weight: 500;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path-text--selected {\n  font-style: italic;\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-border-container {\n  border: 1px solid #f4f4f4;\n  overflow: auto;\n  height: 100%;\n}\n\n.dashboard-color-form__tree-view-border-found-report-title {\n  font-weight: bold;\n  padding: 3px 10px;\n}\n\n.dashboard-color-form__tree-view-wrapper {\n  display: flex;\n  flex: 1 1 50%;\n  flex-direction: column;\n  height: 330px;\n}\n\n.dashboard-color-form__tree-view-wrapper--fixed-height {\n  height: auto;\n}\n\n.dashboard-color-form__tree-view-item-wrapper {\n  display: flex;\n  flex-direction: row;\n  padding: 3px 10px;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper {\n  align-items: center;\n  background: #fff;\n  color: #aaa;\n  cursor: not-allowed;\n  font-weight: normal;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper:hover {\n    background: #fff;\n  }\n\n.dashboard-color-form__tree-view-report-item-wrapper--highlighted {\n  background: #ff0;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--selected {\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--drag {\n  color: inherit;\n  cursor: pointer;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--drag:hover {\n    background: #f5f5f5;\n  }\n\n.dashboard-color-form__tree-view-search-input {\n  background: none;\n  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  min-width: 170px;\n  padding-left: 8px;\n  width: auto;\n}\n\n.dashboard-color-form__tree-view-search-input::placeholder {\n    color: #ccc;\n    padding-left: 20px;\n  }\n\n.dashboard-color-form__tree-view-search-input--magnifier {\n  background: url('public/img/magnifier.png') 8px 10px no-repeat;\n}\n\n.dashboard-text-row-form__table {\n  margin-bottom: 0;\n  min-width: 380px;\n  width: auto;\n}\n\n.dashboard-text-row-form-first__td {\n  text-align: center;\n  vertical-align: middle !important;\n  width: 20px;\n}\n\n.dashboard-custom-frame__panel-toolbox {\n  min-height: auto;\n}\n\n.dashboard-custom-frame__panel-toolbox--editable {\n  min-height: 1.42857143em;\n}\n\n.dashboard-custom-frame__hover {\n  align-items: center;\n  background: rgba(255, 255, 255, 0.7);\n  bottom: 0;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.dashboard-edit-bar__row {\n  margin-top: 10px;\n  padding-right: 20px;\n}\n\n.dashboard-device-chart__title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.dashboard-device-chart__col {\n  min-width: 900px;\n  position: relative;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n\n.dashboard-device-chart__col {\n    min-width: 700px\n}\n  }\n\n.dashboard-vendor-mix__title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.dashboard-table-color__summary-table-row {\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n\n.dashboard-table-color__summary-table-row {\n    clear: both;\n    max-width: 550px\n}\n  }\n\n.dashboard-text-row__tr {\n  border-bottom: 1px solid #fff;\n}\n\n.dashboard-text-row__tr:hover {\n    border-bottom: 1px solid #f4f4f4;\n  }\n\n.dashboard-text-row__td {\n  padding-bottom: 2px;\n  padding-top: 2px;\n  text-align: left;\n  white-space: normal;\n  width: 1%;\n}\n\n.dashboard-text-row__value {\n  float: right;\n  margin-left: 20px;\n}\n\n.dashboard-text-row__wrapper {\n  clear: both;\n  max-width: 550px;\n  width: 100%;\n}\n\n.dashboard-color-form__title-widget-input {\n  width: auto;\n  min-width: 170px;\n  margin-bottom: 5px;\n}\n",":root {\n  --background-color: #f4f4f4;\n}\n\n.dazzle .x_title h2 {\n  float: left;\n  margin: 10px 0 3px;\n  font-size: 1.6em;\n}\n\n.dazzle .x_title .nav > li > a {\n  cursor: pointer;\n  padding: 0;\n}\n\n.dazzle .x_title .nav > li > a:hover, .dazzle .x_title .nav > li > a:active, .dazzle .x_title .nav > li > a:focus {\n  background: none;\n}\n\n.dazzle .x_title .navbar-right {\n  margin: 0;\n}\n\n.dashboard .list-group-item-heading {\n  margin-bottom: 0;\n  font-size: 1em;\n}\n\n.dashboard .box-header {\n  text-align: left;\n}\n\n.dashboard .box-body-textrow {\n  box-shadow: 0 1px 3px #0000004d !important;\n}\n\n.dashboard .group-summary-select-widget {\n  margin: 0 15px;\n}\n\n.dashboard .group-summary-edit-groups {\n  max-height: 350px;\n  overflow-y: hidden;\n}\n\n.dashboard .addwidget-group-report.over {\n  background: #eee;\n}\n\n.dashboard .DeviceChart-panel {\n  width: 100%;\n}\n\n.dashboard-layout-field__layout-wrapper {\n  background: var(--background-color);\n  cursor: pointer;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  margin-bottom: 20px;\n  padding: 10px;\n}\n\n.dashboard-layout-field__layout-wrapper:hover {\n  border: 1px solid #d2d6de;\n}\n\n.dashboard-layout-field__td {\n  border: 1px solid var(--background-color);\n  border-right: 1px solid var(--background-color);\n  text-align: center;\n  background: #fff;\n  padding: 8px 5px;\n}\n\n.dashboard-layout-field__td:last-of-type {\n  border-right: 1px solid var(--background-color);\n}\n\n.dashboard-layout-field__td--hover {\n  border-right: 1px solid #ddd;\n}\n\n.dashboard-layout-field__hover-block {\n  cursor: pointer;\n  z-index: 1;\n  background: #ffffffb3;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  inset: 0;\n}\n\n.dashboard__empty-icon {\n  width: 12px;\n  display: inline-block;\n}\n\n.dashboard__empty-icon:empty:before {\n  content: \" \";\n}\n\n.dashboard__add-widget-item {\n  border: 1px solid #fff;\n  border-radius: 3px;\n  margin-bottom: 8px;\n  background: #f4f4f4 !important;\n}\n\n.dashboard__add-widget-item:last-of-type {\n  margin-bottom: 0;\n}\n\n.dashboard__add-widget-item:hover {\n  border: 1px solid #d2d6de;\n}\n\n.dashboard__add-widget-footer {\n  border-top: 1px solid #f4f4f4;\n  padding: 10px;\n}\n\n.dashboard-color-form__modify-groups-wrapper {\n  flex-direction: row;\n  padding-bottom: 25px;\n  display: flex;\n}\n\n@media (width >= 1200px) {\n  .dashboard-color-form__row {\n    display: flex;\n  }\n}\n\n.dashboard-color-form__widget-options-field-wrapper {\n  flex-direction: column;\n  flex: 50%;\n  display: flex;\n}\n\n.dashboard-color-form__add-to-group-icon {\n  color: #d2d6de;\n  cursor: not-allowed;\n  text-align: center;\n  background: #eee;\n  border: 1px solid #d2d6de;\n  border-radius: 15px;\n  width: 30px;\n  height: 30px;\n  padding-top: 6px;\n}\n\n.dashboard-color-form__add-to-group-icon--selected {\n  color: #3c763d;\n  cursor: pointer;\n  background: #fff;\n}\n\n.dashboard-color-form__add-to-group-wrapper {\n  z-index: 1;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  margin: 0 5px;\n  display: flex;\n  position: relative;\n}\n\n.dashboard-color-form__add-to-group-wrapper:before {\n  content: \"\";\n  z-index: -1;\n  border-left: 1px solid #f4f4f4;\n  width: 1px;\n  margin: 0 auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n}\n\n.dashboard-color-form__group-report-path {\n  margin-left: 35px;\n  display: none;\n}\n\n@media (width >= 1200px) {\n  .dashboard-color-form__group-report-path {\n    display: inline-block;\n  }\n}\n\n.dashboard-color-form__group-report-path-text {\n  font-style: italic;\n  font-weight: 500;\n}\n\n.dashboard-color-form__weight-input {\n  border: 1px solid #d2d6de;\n  height: 22px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.dashboard-color-form__weight-input--error {\n  border: 1px solid #ff3232;\n}\n\n.dashboard-color-form__group-wrapper {\n  background-color: #fff;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 190px 115px;\n  border: 0;\n  height: 252px;\n  padding: 0;\n  overflow-y: auto;\n}\n\n.dashboard-color-form__group-wrapper--children {\n  background-image: url(\"public/img/dragdrop-transparent.png\");\n  border: 1px solid #f4f4f4;\n}\n\n.dashboard-color-form__group-wrapper--over {\n  background-color: #f5f5f5;\n}\n\n.dashboard-color-form__no-groups {\n  border: 2px dashed #ddd;\n  border-radius: 10px;\n  justify-content: center;\n  align-items: center;\n  height: 249px;\n  display: flex;\n}\n\n.dashboard-color-form__no-groups--error {\n  border: 2px dashed #ff3232;\n}\n\n.dashboard-color-form__groups-th {\n  max-width: 70px;\n  border-bottom-width: 1px !important;\n}\n\n.dashboard-color-form__groups-th:first-of-type {\n  width: auto;\n}\n\n.dashboard-color-form__groups-th:last-of-type {\n  text-align: center;\n  max-width: 40px;\n}\n\n.dashboard-color-form__groups-td {\n  cursor: pointer;\n  vertical-align: middle !important;\n  border-top: 0 !important;\n}\n\n.dashboard-color-form__groups-td:last-of-type {\n  text-align: center;\n}\n\n.dashboard-color-form__col {\n  background: #f4f4f4;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  margin: 15px;\n  padding-top: 15px;\n}\n\n.dashboard-color-form__col:hover {\n  border: 1px solid #fff;\n}\n\n@media (width >= 1200px) {\n  .dashboard-color-form__col {\n    cursor: pointer;\n    flex-direction: column;\n    margin: 0 7px;\n    display: flex;\n  }\n\n  .dashboard-color-form__col:first-of-type {\n    margin-left: 14px;\n  }\n\n  .dashboard-color-form__col:last-of-type {\n    margin-right: 14px;\n  }\n}\n\n.dashboard-color-form__col--checked {\n  border: 1px solid #3c8dbc;\n}\n\n.dashboard-color-form__empty-space {\n  width: 13px;\n}\n\n.dashboard-color-form__empty-space:empty:before {\n  content: \" \";\n}\n\n.dashboard-color-form__caret-icon {\n  cursor: pointer;\n  width: 12px;\n  padding-right: 4px;\n}\n\n.dashboard-color-form__tree-view-found-report-item {\n  color: #aaa;\n  cursor: not-allowed;\n  padding: 3px 10px;\n  font-weight: normal;\n}\n\n.dashboard-color-form__tree-view-found-report-item:hover {\n  background: #fff;\n}\n\n.dashboard-color-form__tree-view-found-report-item--drag {\n  color: inherit;\n  cursor: pointer;\n}\n\n.dashboard-color-form__tree-view-found-report-item--drag:hover {\n  background: #f5f5f5;\n}\n\n.dashboard-color-form__tree-view-found-report-item--selected {\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path {\n  margin-left: 35px;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path-text {\n  font-style: italic;\n  font-weight: 500;\n}\n\n.dashboard-color-form__tree-view-found-report-item-path-text--selected {\n  font-style: italic;\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-border-container {\n  border: 1px solid #f4f4f4;\n  height: 100%;\n  overflow: auto;\n}\n\n.dashboard-color-form__tree-view-border-found-report-title {\n  padding: 3px 10px;\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-wrapper {\n  flex-direction: column;\n  flex: 50%;\n  height: 330px;\n  display: flex;\n}\n\n.dashboard-color-form__tree-view-wrapper--fixed-height {\n  height: auto;\n}\n\n.dashboard-color-form__tree-view-item-wrapper {\n  flex-direction: row;\n  padding: 3px 10px;\n  display: flex;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper {\n  color: #aaa;\n  cursor: not-allowed;\n  background: #fff;\n  align-items: center;\n  font-weight: normal;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper:hover {\n  background: #fff;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--highlighted {\n  background: #ff0;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--selected {\n  font-weight: bold;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--drag {\n  color: inherit;\n  cursor: pointer;\n}\n\n.dashboard-color-form__tree-view-report-item-wrapper--drag:hover {\n  background: #f5f5f5;\n}\n\n.dashboard-color-form__tree-view-search-input {\n  background: none;\n  width: auto;\n  min-width: 170px;\n  padding-left: 8px;\n  font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial, sans-serif;\n}\n\n.dashboard-color-form__tree-view-search-input::placeholder {\n  color: #ccc;\n  padding-left: 20px;\n}\n\n.dashboard-color-form__tree-view-search-input--magnifier {\n  background: url(\"public/img/magnifier.png\") 8px 10px no-repeat;\n}\n\n.dashboard-text-row-form__table {\n  width: auto;\n  min-width: 380px;\n  margin-bottom: 0;\n}\n\n.dashboard-text-row-form-first__td {\n  text-align: center;\n  width: 20px;\n  vertical-align: middle !important;\n}\n\n.dashboard-custom-frame__panel-toolbox {\n  min-height: auto;\n}\n\n.dashboard-custom-frame__panel-toolbox--editable {\n  min-height: 1.42857em;\n}\n\n.dashboard-custom-frame__hover {\n  cursor: pointer;\n  z-index: 1;\n  background: #ffffffb3;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  position: absolute;\n  inset: 0;\n}\n\n.dashboard-edit-bar__row {\n  margin-top: 10px;\n  padding-right: 20px;\n}\n\n.dashboard-device-chart__title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.dashboard-device-chart__col {\n  width: 100%;\n  min-width: 900px;\n  position: relative;\n}\n\n@media (width >= 992px) {\n  .dashboard-device-chart__col {\n    min-width: 700px;\n  }\n}\n\n.dashboard-vendor-mix__title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.dashboard-table-color__summary-table-row {\n  width: 100%;\n}\n\n@media (width >= 768px) {\n  .dashboard-table-color__summary-table-row {\n    clear: both;\n    max-width: 550px;\n  }\n}\n\n.dashboard-text-row__tr {\n  border-bottom: 1px solid #fff;\n}\n\n.dashboard-text-row__tr:hover {\n  border-bottom: 1px solid #f4f4f4;\n}\n\n.dashboard-text-row__td {\n  text-align: left;\n  white-space: normal;\n  width: 1%;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.dashboard-text-row__value {\n  float: right;\n  margin-left: 20px;\n}\n\n.dashboard-text-row__wrapper {\n  clear: both;\n  width: 100%;\n  max-width: 550px;\n}\n\n.dashboard-color-form__title-widget-input {\n  width: auto;\n  min-width: 170px;\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
